import React from "react"
import { Wrapper } from "./styles"

export function FeedbackImage({ link, imageUrl }) {
	return (
		<Wrapper>
			<a href={link} target="_blank" rel="noreferrer">
				<img src={imageUrl} alt="Sheroes" />
			</a>
		</Wrapper>
	)
}
